import { Text } from "@lightningtv/solid";

export default () => {
  return <Text>Not Found</Text>;
};
